export const ClusterIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="#666"
      d="m.412 4.915 7.734 3.508a.85.85 0 0 0 .707 0l7.734-3.508c.55-.25.55-1.08 0-1.33L8.854.078a.85.85 0 0 0-.707 0L.412 3.585c-.55.25-.55 1.08 0 1.33Zm16.176 2.931-1.929-.874-5.367 2.433a1.905 1.905 0 0 1-1.584 0L2.34 6.972l-1.929.874c-.55.25-.55 1.08 0 1.328l7.734 3.506a.852.852 0 0 0 .707 0l7.735-3.506c.55-.249.55-1.079 0-1.328Zm0 4.243-1.922-.87-5.374 2.436a1.905 1.905 0 0 1-1.584 0l-5.374-2.437-1.922.871c-.55.25-.55 1.08 0 1.328l7.734 3.506a.852.852 0 0 0 .707 0l7.735-3.506c.55-.249.55-1.079 0-1.328Z"
    />
  </svg>
);
